import { ListOfValue } from './models/ListOfValue';

export default function mapLOV(lovValues: ListOfValue[]) {
  return lovValues.map((lov) => ({
    label: lov?.translatedValue,
    value: lov.id,
  }));
}

export function mapLovTable(lov: ListOfValue): string {
  return lov?.translatedValue;
}

export function mapLovTableCode(lov: ListOfValue): string {
  return lov?.code;
}

export const groupBy = <T, K extends keyof any>(
  array: T[],
  key: (index: T) => K,
) =>
  array.reduce(
    (groups, item) => {
      (groups[key(item)] ||= []).push(item);
      return groups;
    },
    {} as Record<K, T[]>,
  );
